import moment from "moment";

export const monthStamp = () => {
  const beginAt = moment()
    .startOf("month")
    .toISOString();

  const endAt = moment
    .utc()
    .endOf("month")
    .toISOString();

  return {
    beginAt,
    endAt,
  };
};

export const sixMonthStamp = (endDate?: string) => {
  const end = endDate ? moment(endDate) : moment();

  const beginAt = moment(end)
    .subtract(5, "months")
    .startOf("month")
    .toISOString();

  // const endAt = moment(end)
  //   .endOf("month")
  //   .endOf("day")
  //   .toISOString();

  const endAt = moment
    .utc(end)
    .endOf("month")
    .toISOString();

  return {
    beginAt,
    endAt,
  };
};

export const weekStamp = () => {
  const beginAt = moment()
    .startOf("week")
    .format("YYYY-MM-DD");

  const endAt = moment()
    .endOf("week")
    .format("YYYY-MM-DD");

  return {
    beginAt,
    endAt,
  };
};

export const getDayStartISO = (date: string) => {
  return moment(date)
    .startOf("day")
    .toISOString();
};

export const getDayEndISO = (date: string) => {
  return moment(date)
    .endOf("day")
    .toISOString();
};

export const getDayStartLocal = (date: string) => {
  return moment(date)
    .startOf("day")
    .format("YYYY-MM-DDTHH:mm:ss.SSS[Z]");
};

export const getDayEndLocal = (date: string) => {
  return moment(date)
    .endOf("day")
    .format("YYYY-MM-DDTHH:mm:ss.SSS[Z]");
};
